import Vue from 'vue';
import axios from 'axios'
import { Notification } from 'element-ui';
import cookie from 'js-cookie'
import router from '../../router'

let baseURL;
//baseURL = process.env.VUE_APP_BASE_API; // vue3是BASE_URL

//if (process.env.NODE_ENV === 'test') {
//    baseURL = 'https://scm-m-test.upower.com'
//} else if (process.env.NODE_ENV === 'production') {
//    baseURL = 'https://scm-m.upower.com'
//} else {
//    console.log('非测试生产环境')
//    console.log('baseURL：', baseURL);
//}

const host = window.location.hostname;
if (process.env.NODE_ENV === 'test') {
   if ( host.includes('scm-test.upower.com') ) {
       baseURL = 'https://scm-m-test.upower.com'
   } else if ( host.includes('scm-uat.upower.com') ) {
       baseURL = 'https://scm-m-uat.upower.com'
   }
    console.log('当前访问域名是：', host, 'api地址是', baseURL);
} else if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://scm-m.upower.com';
    console.log('当前访问域名是：', host, 'api地址是', baseURL);
} else {
    console.log('当前访问域名是：', host, 'api地址是', baseURL);
    if ( host.includes('localhost') || host.includes('10.0.19')) {
        console.log('本地开发环境')
   } else {
        console.log('服务环境错误')
    }
}

console.log('env是：', process.env);

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;
// console.log('环境env配置',process.env);
// console.log('baseURL2 是',baseURL);

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;
//let config = {
//    headers: {
//        "X-Splat-Subsystem": "rms",
//        "x-dubbo-http1.1-dubbo-version": "1.0.0",
//        "x-dubbo-service-protocol": "dubbo",
//        "x-dubbo-service-version": "1.0.0",
//        "Content-Type":"application/json",
//    }
//};

let config = {
    headers: {
        "X-Splat-Subsystem": "rms",
        "tri-service-version": "svc-version-1",
        "tri-req-id": "test-req-id-1",
        "Content-Type": "application/json",
    }
};

const _axios = axios.create(config);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        return response.data;
    },
    async function (error) {
        if (error.response && error.response.status == 401) {
            window.location = "/login"
            return Promise.reject("invalid login status");
        } else if (error.response && error.response.status == 520) {
            return Promise.reject(error);
        }

        // 如果token失效就返回登录页
        // console.log('axios error is ', error)
        let erroData = error.response.data;
        let tokenLose = 'token valid failed';
        if (erroData.includes(tokenLose)) {
            console.log('判断token是否失效拉', error.response.data);
            cookie.remove('token');
            cookie.remove('identity');
            router.push({ path: '/login' });
            this.$message.warning('请重新登录')
        }

        console.log('error.message', error.message);
        // let msg = error.message;
        // // if (error.response && error.response.data.msg) {
        // //     msg = error.response.data.msg
        // // }
        // // 如果token失效就返回登录页
        // if (msg.includes(tokenLose)) {
        //     this.$cookie.remove('token');
        //     this.$router.push('/login')
        // }

        // alert the Notification only for the operation
        // if (error.response.config.method != 'get') {
        //     console.log('Notification.error(msg)', Notification.error(msg))
        // }

        return Promise.reject(error);
    }
);


export default _axios


